define('taoQtiItem/qtiItem/core/interactions/HotspotInteraction',['taoQtiItem/qtiItem/core/interactions/GraphicInteraction'], function(GraphicInteraction){
    var HotspotInteraction = GraphicInteraction.extend({
        qtiClass : 'hotspotInteraction'
    });
    return HotspotInteraction;
});


